import {RoutesPaths} from '../../routes/routes-paths/routes-paths';

export const SettingsRoutesPaths = {
  CHANGE_PASSWORD_OLD_PASSWORD_FORM: RoutesPaths.SETTINGS + '/old-password-form',
  CHANGE_PASSWORD_NEW_PASSWORD_FORM: RoutesPaths.SETTINGS + '/new-password-form',
  CHANGE_PASSWORD_OTP: RoutesPaths.SETTINGS + '/change-password-otp',
  CHANGE_PASSWORD_SUCCESS: RoutesPaths.SETTINGS + '/change-password-succcess'
};
